<template>
  <div class="page-container">
    <div class="header">
        <img src="https://bank.giftoceanmall.com/9140420260423110614260.jpg" alt="" class="header_img">
        <div class="header_click" @click="showPopup = true"></div>
    </div>
    <div class="goodsList" v-for="(item,index) in goodsList"  @click="goDetail(item.id)" style="margin-bottom: 15px;">
      
      <div class="goods_img">
        <div class="goods_xl">
          <!-- <img src="https://bank.giftoceanmall.com/477fc202604231134248630.png" alt=""> -->
           <p>限量</p>
           <p>100</p>
        </div>
        <img :src="item.image" alt="">
      </div>
      <div class="goods_info">
        <div class="info_tit" style="font-size: 15px;color: #e90c30;text-align: center;font-weight: bold;margin-top: 10px;">
          {{ item.store_name }}
        </div>
        <div class="info_name">
          {{item.name}}
        </div>
        <div class="info_back">
          <div style="font-size: 8px; color: #5e5c5d;text-decoration: line-through;">市场价{{ item.ot_price }}</div>
          <div style="color: #fff;font-size: 10px;">
            <p>
              直降
            </p>
            <p>
              {{(item.ot_price-item.price).toFixed(1)}}元
            </p>
          </div>
          <div style="font-size: 8px;color: #5e5c5d;text-decoration: line-through;">市场价{{ item.ot_price}}</div>
        </div>
        <div class="goods_price">
          <div>
            <span style="font-size: 8px;">活动价￥</span>
            <span style="font-size: 16px;font-weight: bold;">{{ item.price }}</span>
          </div>
          <!-- <div>
            {{ item.fenqi_price }}*{{ item.fenqi_num }}期
          </div> -->
          <div>
            <img src="https://bank.giftoceanmall.com/4f993202607081729386889.png" alt="">
          </div>
        </div>
      </div>
    </div>
    
    
    
    <div class="goods_btn" @click="goDianpu()">
      更多特惠好物 低价抢购
    </div>
    <div class="demo-page">
        <MobilePopup 
        :visible="showPopup"
        @close="showPopup = false"
        content-width="90%"
        :border-radius="16"
        :image-src="xz"
        > 
        </MobilePopup>
    </div>
  </div>

   
</template>

<script>
import { goShopDetail } from "@libs/order";
import MobilePopup from './MobilePopup.vue'
import { getProducts, getProductClassCollection } from "@api/store";
export default {
  name: 'Activity1',
  components: {
    MobilePopup
  },
  data() {
    return {
      showPopup:false,
      goodsList:[],
      jdth:[],
      sjsm:[],
      ydfs:[],
      shhw:[],
      jjth:[],
      mzth:[],
      wbhj:[],
      xz:''
    }
      
  },
  mounted() {
    this.getGoodsList();
    // this.getjdth(); 
    // this.getSjsm();
    // this.getydfs();
    // this.getjjth();
    // this.getMmzth();
    // this.getWbhj();
  },
  methods: {
    getGoodsList() {
      let q = {
        id: 47,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.goodsList = res.data.list;
        this.xz = res.data.image;
      });
    },
     getjdth() {
      let q = {
        id: 23,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.jdth = res.data.list;
      });
    },
    getSjsm() {
      let q = {
        id: 24,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.sjsm = res.data.list;
      });
    },
    getydfs() {
      console.log(this.ydfs);
      let q = {
        id: 25,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.ydfs = res.data.list;
      });
    },
    getjjth() {
      let q = {
        id: 26,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.jjth = res.data.list;
      });
    },
    getMmzth() {
      let q = {
        id: 27,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.mzth = res.data.list;
      });
    },
    getWbhj() {
      let q = {
        id: 28,
        page: 1,
        limit: 99,
      }
      getProductClassCollection(q).then((res) => {
        this.wbhj = res.data.list;
      });
    },
    goDianpu() {
      this.$router.push({ path: "/"});
    },
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  width: 100%;
  height: auto;
  background-color: #d41b2e;
  padding-bottom: 30px;
}
.header{
  width: 100%;
  height: auto;
  position: relative;
  .header_img{
    width: 100%;
  }
  .header_click{
    position: absolute;
    width: 50px;
    height: 80px;
    top: 0px;
    right: 0px;
  }
}
.goodsList{
  width: 90%;
  margin: 0 auto;
  background-color: #fff;
  height: 150px;
  border-radius: 10px;
  display: flex;
  .goods_img{
    width: 150px;
    height: 150px;
    border-radius: 10px 0px 0px 10px;
    position: relative;
    img{
      width: 150px;
      height: 150px;
      border-radius: 10px 0px 0px 10px;
    }
    .goods_xl{
      width: 38px;
      height: 36px;
      position: absolute;
      top:-2px;
      left: 20px;
      background-image: url(https://bank.giftoceanmall.com/477fc202604231134248630.png) ;
      background-size: 100%;
      color: #fff;
      font-size: 10px;
      text-align: center;
      
    }
  }
  .goods_info{
    width: 230px;
    height: 150px;
    background-color: #fcebef;
    border-radius: 0px 10px 10px 0px;
  }
  
}
.goods_list{
    width: 95%;
    // height: 490px;
    margin: 0 auto;
    background-image: url(https://bank.giftoceanmall.com/496e720260423143922258.png);
    background-size: 100%;
    .goods_list_tit{
      width: 150px;
      color: #fcedf1;
      font-size: 24px;
      text-align: center;
      line-height: 60px;
      font-weight: bold;
    }
}
.goods_list1{
  width: 95%;
    // height: 490px;
    margin: 0 auto;
    background-image: url(https://bank.giftoceanmall.com/7a778202604231532404568.png);
    background-size: 100%;
    .goods_list_tit{
      width: 150px;
      color: #fcedf1;
      font-size: 24px;
      text-align: center;
      line-height: 60px;
      font-weight: bold;
    }
}
.info_tit{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.product-list {
      display: -webkit-grid;
      display: grid;
      grid-template-columns: repeat(3, minmax(80px, 1fr));
      gap: 4px;
      width: 93%;
      -webkit-grid-template-columns: repeat(3, minmax(80px, 1fr));
      margin: 0 auto;
  }

  .product-card {
      border: 1px solid #ff4400;
      border-radius: 4px; 
      padding: 5px; 
      text-align: center;
      background-color: #fff;
      position: relative;
      overflow: hidden;
  }
  .discount-tag {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #ff4400;
      color: #fff;
      font-size: 10px; 
      padding: 2px 4px;
      border-radius: 0 0 4px 0;
      font-weight: bold;
  }
  .product-img {
      width: 100%;
      height: 110px; 
      object-fit: contain;
      margin: 5px 0;
  }

  .product-name {
      font-size: 11px; 
      color: #333;
      line-height: 1.3;
      margin: 3px 0;
      height: 30px; 
      overflow: hidden;
  }

  .installment {
      font-size: 10px;
      color: #666;
      margin: 2px 0;
  }

  .price-area {
      display: flex;
      align-items: baseline;
      justify-content: center;
      gap: 2px;
      margin: 3px 0;
      width: 100%;
      background: #ff4400;
      
  }

  .price-label {
      font-size: 10px;
      color: #fff;
  }

  .price {
      font-size: 14px; 
      color: #fff;
      font-weight: bold;
  }
  .goods_btn{
    width: 65%;
    height: 46px;
    margin: 30px auto;
    background-image: url(https://bank.giftoceanmall.com/a2dc8202604231550053177.png);
    background-size: 100%;
    text-align: center;
    color: #fff;
    font-size: 20px;
    line-height: 46px;
  }
  .info_back{
    width: 80%;
    height: 58px;
    background-image: url(https://bank.giftoceanmall.com/0c16b20260708165740190.png);
    background-size: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size:10px;
  }
  .goods_price{
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    img{
      width: 30px;
      height: 30px;
    }
  }
</style>